import angular from 'angular';

angular.module('cloudX').directive('cxEmailTemplateSelect', [
  function() {
    return {
      restrict: 'E',
      template: `<a href="#" editable-select="value" onbeforesave="beforeSave($data)" e-ng-options="t.id as (t.id | translateList:'template':t.name) for t in templates | filter:{context:context}:true | orderBy:'name'" edit-disabled="disabled" e-placeholder="{{'Use company setting'|translate}}">
        <span>{{getDisplayValue()}}</span>
        <span ng-show="!value">{{'Use company setting'|translate}}</span>
        <span ng-show="showMismatchWarning" title="{{('This template can normally not be selected. (Probably the wrong language)'|translate)}}"><i class="fa fa-exclamation-triangle text-warning"></i></span>
        </a>`,
      scope: {
        value: '=data',
        save: '&',
        context: '<',
        disabled: '=',
      },
      controller: [
        '$scope',
        'templateHttpSvc',
        function($scope, templateHttpSvc) {
          $scope.templates = [];
          $scope.showMismatchWarning = false;
          $scope.beforeSave = function(newValue) {
            if (newValue) {
              const template = $scope.templates.find(x => x.id === newValue);
              $scope.showMismatchWarning = template ? !!template.isMismatch : true;
            } else {
              $scope.showMismatchWarning = false;
            }

            $scope.save({ newValue });
          };

          $scope.reloadTemplates = function() {
            return templateHttpSvc.getTemplates().then(function(data) {
              $scope.templates = data;
              if ($scope.value) {
                const template = data.find(x => x.id === $scope.value);
                if (template == null) {
                  $scope.showMismatchWarning = true;
                } else {
                  $scope.showMismatchWarning = false;
                }
              }
              return data;
            });
          };

          $scope.getDisplayValue = () => {
            if (!$scope.value || !$scope.templates) return null;
            const template = $scope.templates.find(x => x.id === $scope.value);
            return template ? template.name : null;
          };

          $scope.reloadTemplates();
        },
      ],
    };
  },
]);
